function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 345 175.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M214.05,0V58.49H203.37l-17-29.5v29.5H173.11V0h10.6l17.12,29.92V0Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.85,0l6.53,19.58L244.9,0h15.6L245.41,36.11V58.49H231.34V36.11L216.25,0Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.18,58.49,270,0h13.9l16.79,58.49H285.9l-2.21-10H270.05l-2.21,10Zm20.17-21.7h6.95l-3.39-17Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,0V58.49H332.35l-17-29.5v29.5H302.09V0h10.59L329.8,29.92V0Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.73,58.49H10.34L0,0H15.34l3.9,32.38L27.12,0H39.33l7.88,32.38L51.2,0H66.45L56.11,58.49H42.72L33.23,23.23Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,58.49,80.77,0h13.9l16.78,58.49H96.71l-2.21-10H80.85l-2.2,10Zm20.17-21.7h7l-3.39-17Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.84,0V58.49H143.16l-17-29.5v29.5H112.9V0h10.59l17.12,29.92V0Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.22,173.65H19L.38,68.08H28.07l7,58.45L49.34,68.08h22L85.6,126.53l7.19-58.45h27.54L101.66,173.65H77.49L60.35,110Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.64,173.65l30.3-105.57H168l30.29,105.57H171.7l-4-18.05H143.09l-4,18.05Zm36.42-39.17H161.6l-6.12-30.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.28,173.65l-13.61-39.93H226v39.93h-25.4V68.08h35.49c20.66,0,34.73,11.17,34.73,33.2,0,13.77-5.2,23-13.15,27.69l16.52,44.68ZM232,112.6c7.19,0,13.46-1.37,13.46-11.32S239.17,89.2,232,89.2h-6v23.4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.49,97.3c-3.21-7-7.5-9.63-13.62-9.63-6.42,0-8.87,3.82-8.87,9.18,0,6.27,3.52,9.17,14.23,13.15,19.89,7.35,26.77,15.61,26.77,33.66,0,19.13-12.09,31.52-32.13,31.52-16.67,0-27.84-4.74-36.72-17.29l17.75-13.31c4.13,6.58,9.64,9.48,15.61,9.48,7.65,0,10.09-4.13,10.09-9.17,0-6.12-2.6-8.88-15.14-13.77C286.1,124.08,278.6,114,278.6,97c0-17.44,10.56-30.45,32.74-30.45,14.23,0,26.47,5.66,32.74,17.29Z",
    style: {
      fill: "#f5f5f5"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSp);
export default __webpack_public_path__ + "static/media/logo-sp.4f0a7bb8.svg";
export { ForwardRef as ReactComponent };